import { useState } from "react";
import { Button, DialogContent, DialogTitle, IconButton, InputAdornment, TextField } from "@mui/material";
import axios from "axios";
import { useForm, Controller } from "react-hook-form";
import { authData } from "../../components/GetAuth";
import styles from "./Popup.module.css";
import { Close, Visibility, VisibilityOff } from "@mui/icons-material";
import { X, Check } from "react-feather";

// 8-15 chars, at least 1 lowercase, 1 uppercase, 1 number, 1 special character
const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()\-_+=[\]{};:'",.<>/?\\|`~]).{8,15}$/;

const ChangePasswordForm = ({ setFormOpen, setSnackbarOpen, setSnackbarMessage, setSnackbarType, setLoading, id }) => {
  const auth = authData();
  const API_TOKEN = auth?.api_token;

  const [showPassword, setShowPassword] = useState(false);
  const [showConfPassword, setShowConfPassword] = useState(false);

  const { handleSubmit, control, watch, formState: { errors } } = useForm({
    mode: "onChange",
  });

  const onSubmit = (data) => {
    setLoading(true);
    setFormOpen(false);

    axios.put(process.env.REACT_APP_API_URL + "v1/users/change-password/" + id, { password: data?.password }, {
      headers: {
        Authorization: `Bearer ${API_TOKEN}`,
      }
    }).then((response) => {
      setLoading(false);
      if (response.data.status === "SUCCESS") {
        setSnackbarOpen(true);
        setSnackbarMessage(response.data.message);
        setSnackbarType("success");
      }
      if (response.data.status === "ERROR") {
        setSnackbarOpen(true);
        setSnackbarMessage(response.data.message);
        setSnackbarType("error");
      }
    }).catch((error) => {
      setLoading(false);
      if (error && error.response && error.response.data && error.response.data.messages) {
        setSnackbarOpen(true);
        setSnackbarMessage(error.response.data.messages);
        setSnackbarType("error");
      }
    });
  };

  return (<>
    <DialogTitle id="alert-dialog-title" className={`${styles.PopupTitleBar}`}>
      Change Password
      <IconButton onClick={(e) => setFormOpen(false)} className={`${styles.PopupCloseBU}`} aria-label="Close"><Close /></IconButton>
    </DialogTitle>
    <DialogContent className={`${styles.PopupContent}`}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className={`${styles.FormMainRow}`}>
          <div className={`${styles.FormGroupFull}`}>
            <Controller
              name="password"
              control={control}
              rules={{
                required: "This field is Required",
                pattern: {
                  value: PASSWORD_REGEX,
                  message: "8-15 characters, with uppercase, lowercase, number & special character",
                },
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Password*"
                  variant="outlined"
                  type={showPassword ? "text" : "password"}
                  fullWidth
                  inputProps={{ maxLength: 15 }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowPassword((prev) => !prev)}
                          edge="end"
                          aria-label={showPassword ? "Hide password" : "Show password"}
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              )}
            />
            {errors.password
              ? <span className={`${styles.ErrorM}`}>{errors?.password?.message}</span>
              : <span className={`${styles.HintText}`}>8-15 characters, 1 uppercase, 1 lowercase, 1 number, 1 special character</span>
            }
          </div>
          <div className={`${styles.FormGroupFull}`}>
            <Controller
              name="conf_password"
              control={control}
              rules={{
                required: "This field is Required",
                validate: (val) => watch("password") === val || "Your passwords do not match",
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  id="outlined-basic"
                  label="Confirm Password*"
                  variant="outlined"
                  type={showConfPassword ? "text" : "password"}
                  fullWidth
                  inputProps={{ maxLength: 15 }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowConfPassword((prev) => !prev)}
                          edge="end"
                          aria-label={showConfPassword ? "Hide password" : "Show password"}
                        >
                          {showConfPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              )}
            />
            {errors.conf_password && (<span className={`${styles.ErrorM}`}>{errors?.conf_password?.message}</span>)}
          </div>
        </div>
        <div className={`${styles.ButtonAction}`}>
          <Button className={`${styles.CancelPopupBU}`} startIcon={<X size={16} />} onClick={(e) => setFormOpen(false)}>Cancel</Button>
          <Button className={`${styles.SubmitPopupBU}`} startIcon={<Check size={16} />} type="submit">Change</Button>
        </div>
      </form>
    </DialogContent>
  </>);
};

export default ChangePasswordForm;